import { useInject } from '@actr/di/src/hook/use-inject';
import { useNavigation } from '@actr/hooks/src/navigation/hook';
import { Header, HeaderManagerRef } from '@actr/widgets/src/components/_misc/layouts/header';
import { AkV2Routes } from '@actr/widgets/src/navigation/routes/ak-v2';
import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useRef } from 'react';

import LocalAuthStore from '@/store/auth';

const SiteHeader = () => {
  const auth = useInject(LocalAuthStore);
  const { navigate } = useNavigation();

  const headerManagerRef = useRef<HeaderManagerRef>({
    openLoginPopup: () => {}
  });

  useEffect(() => {
    const disposer = reaction(() => auth.loginOpened, value => {
      if (value) {
        headerManagerRef.current?.openLoginPopup();

        auth.toggleOpenLoginForm(false);
      }
    });

    return () => disposer();
  }, []);

  const toHome = useCallback(() => {
    navigate(AkV2Routes.HOME, { useRouter: false });
  }, []);

  return (
    <Header
      ref={headerManagerRef}
      useLoginPopup={true}
      redirectToHome={toHome}
    />
  );
};

export default observer(SiteHeader);
